/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.OMS {
    import fld = DiscountingPolicyDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class DiscountingPolicyDetailsEditor extends _Ext.GridEditorBase<DiscountingPolicyDetailsRow> {
        protected getColumnsKey() { return "OMS.DiscountingPolicyDetails"; }
        protected getDialogType() { return DiscountingPolicyDetailsDialog; }
        protected getLocalTextPrefix() { return DiscountingPolicyDetailsRow.localTextPrefix; }
        exchangerate: number;
        rateid: string;
        public companyid: number;

        public pendingChanges: Q.Dictionary<any> = {};
        public rowSelection = new Serenity.GridRowSelectionMixin(this);

        constructor(container: JQuery) {
            super(container);


        }
        public getColumns() {

            var columns = super.getColumns();

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var id = this.id(item);
            var target = $(e.target);

            if (target.hasClass('check-box no-float readonly') || target.hasClass('check-box no-float readonly checked'))
                target.removeClass('readonly')



            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        this.view.deleteItem(id);
                        this.view.refresh();
                    });
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        protected getButtons() {
            let buttons = super.getButtons();
            buttons[0].title = "Add Detail";

            return buttons;
        }
        validateEntity(row, id) {
            var samepriority = this.view.getItems().filter(x => x.Priority === row.Priority);
            if (samepriority != null && samepriority.length > 1) {
                Q.alert('This Priority already exists!');
                return false;
            }
            if (row.DiscountType == "1") {
                var samedetail = Q.tryFirst(this.view.getItems(), x => x.CategoryId === row.CategoryId && x.SubCategoryId === row.SubCategoryId
                    && x.ProductTypeId === row.ProductTypeId && x.ProcessId === row.ProcessId);
                if (samedetail != null && this.id(samedetail) !== id) {
                    Q.alert('This Detail already exists!');
                    return false;
                }
                row.CategoryCode = OMS.CategoryMasterRow.getLookup().itemById[row.CategoryId].CategoryCode;
                row.SubCategoryCode = row.SubCategoryId != 0 ? OMS.SubCategoryMasterRow.getLookup().itemById[row.SubCategoryId].SubCategoryCode : "NA";
                row.ProductTypeCode = OMS.ProductTypeRow.getLookup().itemById[row.ProductTypeId].ProductTypeCode;
            }
            else if (row.DiscountType == "2") {
                var samedetail = Q.tryFirst(this.view.getItems(),x=>x.ProcessId === row.ProcessId);
                if (samedetail != null && this.id(samedetail) !== id) {
                    Q.alert('This Detail already exists!');
                    return false;
                }
            }
            row.ProcessName = OMS.ProcessMasterRow.getLookup().itemById[row.ProcessId].ProcessName;
            return true;
        }



    }
}